module.exports = __webpack_public_path__ + "static/media/level-down-alt.d8450d6b.svg";